import { gql } from "graphql-tag";

export const streamProfileFieldsFragment = gql`
  fragment StreamProfileFields on StreamProfile {
    id
    label
    order
    enabled
    config {
      resolution
      fps
      bitrate
    }
  }
`;

export const streamProfileOptionsFragment = gql`
  fragment StreamProfileOptions on StreamProfile {
    options {
      supportedResolution {
        value
        enabled
      }
      supportedFPS {
        value
        enabled
      }
      supportedBitrate {
        value
        enabled
      }
    }
  }
`;
